import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useAdmin } from "./AdminLayout";

export default function AdminOverview() {
  const user = useAdmin();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/overview").then(({ data }) => setData(data)).catch(() => setData({})); }, []);

  const can = (p) => user.permissions.includes(p);
  return (
    <div data-testid="admin-overview">
      <h1 className="font-serif text-3xl font-semibold text-forest">Welcome back</h1>
      <p className="mt-2 text-sm text-charcoal/70">
        Signed in as <strong>{user.email}</strong> ({user.role === "SUPER_ADMIN" ? "Super Administrator" : "Administrator"}).
      </p>

      <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {can("donations.read_limited") && (
          <div className="bg-white border border-sandstone p-6" data-testid="overview-donations-card">
            <p className="text-xs tracking-wider uppercase font-semibold text-charcoal/60">Recorded donations</p>
            <p className="mt-3 font-serif text-4xl font-semibold text-forest">
              {data ? `£${(data.donations?.total ?? 0).toLocaleString("en-GB")}` : "—"}
            </p>
            <p className="mt-1 text-xs text-charcoal/60">{data?.donations?.count ?? 0} records (verified CSV imports)</p>
          </div>
        )}
        {can("content.manage") && (
          <>
            <div className="bg-white border border-sandstone p-6">
              <p className="text-xs tracking-wider uppercase font-semibold text-charcoal/60">News articles</p>
              <p className="mt-3 font-serif text-4xl font-semibold text-forest">{data?.articles_published ?? "—"}</p>
              <p className="mt-1 text-xs text-charcoal/60">{data?.articles_draft ?? 0} drafts</p>
            </div>
            <div className="bg-white border border-sandstone p-6">
              <p className="text-xs tracking-wider uppercase font-semibold text-charcoal/60">Unread enquiries</p>
              <p className="mt-3 font-serif text-4xl font-semibold text-forest">{data?.submissions_unread ?? "—"}</p>
            </div>
            <div className="bg-white border border-sandstone p-6">
              <p className="text-xs tracking-wider uppercase font-semibold text-charcoal/60">Confirmed subscribers</p>
              <p className="mt-3 font-serif text-4xl font-semibold text-forest">{data?.subscribers_confirmed ?? "—"}</p>
            </div>
          </>
        )}
      </div>

      {user.role === "DONATION_VIEWER" && (
        <div className="mt-8 bg-sandstone/50 border border-sandstone p-6 text-sm text-charcoal/75 leading-relaxed" data-testid="viewer-scope-note">
          Your administrator access covers news publishing, enquiries, newsletters and read-only
          donation reporting. Website settings, user management, audit logs and donation imports
          are restricted to the Super Administrator. Donation figures reflect verified records
          imported from official donation platform reports.
        </div>
      )}
    </div>
  );
}
